<template>
  <main v-if="$page">
    <PageHeader :content="$page.header" />
    <ImageCTASection
      :content="$page.listening"
      :link="$page.listening_link"
      :page="$page.listening_page"
      reverse
    />
    <CTASection
      :content="$page.vision"
      :link="$page.vision_link"
      :page="$page.vision_page"
      class="--dark"
    />
    <ImageCardsSection :content="$page.actors" />
    <IconCardsSection :content="$page.values" />
    <ImageCardsSection :content="$page.philanthropy" class="--dark --wide --left" />
    <CTASection
      :content="$page.services"
      :link="$page.services_link"
      :page="$page.services_page"
      class="--light"
    />
  </main>
</template>

<script>
import CTASection from '@/components/sections/CTASection.vue'
import IconCardsSection from '@/components/sections/IconCardsSection.vue'
import ImageCardsSection from '@/components/sections/ImageCardsSection.vue'
import ImageCTASection from '@/components/sections/ImageCTASection.vue'
import PageHeader from '@/components/sections/PageHeader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  name: 'Office',
  beetPage: 'firm',
  mixins: [PageMetaMixin],
  components: { CTASection, IconCardsSection, ImageCardsSection, ImageCTASection, PageHeader },
}
</script>
